import VueRouter from 'vue-router';
import AccountStatusSettings from '@/views/AccountStatusSettings.vue';
import TransactionClassification from '@/views/TransactionClassification.vue';
import FiConfigurationSettings from '@/views/FiConfigurationSettings.vue';
import LegacyRedirect from '@/views/LegacyRedirect.vue';
import IncomingRedirect from '@/views/IncomingRedirect.vue';
import CoreManagement from '@/views/CoreManagement.vue';
import RelationshipClassification from '@/views/RelationshipClassification.vue';
import AccountTypes from '@/views/AccountTypes.vue';
import StatementCodes from '@/views/StatementCodes.vue';
import ProcessingDaysAndHolidays from '@/views/ProcessingDaysAndHolidays.vue';
import InterestSettings from '@/views/InterestSettings.vue';
import ATMSettings from '@/views/ATMSettings.vue';
import AuditMessages from '@/views/AuditMessages.vue';
import EocEmailSettings from '@/views/EocEmailSettings.vue';
import CycleSets from '@/views/CycleSets.vue';
import ProductMappings from '@/views/ProductMappings.vue';
import Products from '@/views/Products.vue';
import EngagementRewards from '@/views/EngagementRewards.vue';

const KeyMappingEditor = () => import('@/views/KeyMappingEditor.vue');

const router = new VueRouter({
  routes: [
    {
      path: '/:fiId/incomingredirect/:destination',
      name: 'incomingredirect',
      component: IncomingRedirect,
      props: true,
    },
    {
      path: '/:clientId/fi-configuration',
      name: 'fiConfiguration',
      component: FiConfigurationSettings,
    },
    {
      path: '/:clientId/transactionclassification',
      name: 'transactionclassification',
      component: TransactionClassification,
    },
    {
      path: '/:clientId',
      redirect: '/:clientId/fi-configuration',
    },
    {
      path: '/:clientId/accountstatussettings',
      name: 'accountstatussettings',
      component: AccountStatusSettings,
    },
    {
      path: '/:clientId/coremanagement',
      name: 'coremanagement',
      component: CoreManagement,
    },
    {
      path: '/:clientId/relationshipclassification',
      name: 'relationshipclassification',
      component: RelationshipClassification,
    },
    {
      path: '/:clientId/accounttypemappingrules',
      name: 'accounttypemappingrules',
      component: AccountTypes,
    },
    {
      path: '/:clientId/statementcodemappingsrules',
      name: 'statementcodemappingsrules',
      component: StatementCodes,
    },
    {
      path: '/:clientId/processingdaysandholidays',
      name: 'processingdaysandholidays',
      component: ProcessingDaysAndHolidays,
    },
    {
      path: '/:clientId/interestsettings',
      name: 'interestsettings',
      component: InterestSettings,
    },
    {
      path: '/:clientId/atmsettings',
      name: 'atmsettings',
      component: ATMSettings,
    },
    {
      path: '/:clientId/auditmessages',
      name: 'auditmessages',
      component: AuditMessages,
    },
    {
      path: '/:clientId/eocemailsettings',
      name: 'eocemailsettings',
      component: EocEmailSettings,
    },
    {
      path: '/:clientId/cyclesets',
      name: 'cyclesets',
      component: CycleSets,
    },
    {
      path: '/:clientId/productmappings',
      name: 'productmappings',
      component: ProductMappings,
    },
    {
      path: '/:clientId/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/:clientId/product/:productId',
      name: 'product',
      component: Products,
    },
    {
      path: '/:clientId/product',
      name: 'newproduct',
      component: Products,
    },
    {
      path: '/:clientId/engagementrewards',
      name: 'engagementRewards',
      component: EngagementRewards,
    },
    {
      path: '/:clientId/engagementreward/:rewardId/:designStartDate',
      name: 'engagementReward',
      component: EngagementRewards,
    },
    {
      path: '/:clientId/engagementreward',
      name: 'newEngagementReward',
      component: EngagementRewards,
    },
    {
      path: '/legacyredirect/:destination',
      name: 'legacyredirect',
      component: LegacyRedirect,
      props: true,
    },
    {
      path: '/:clientId/keymappingeditor',
      name: 'keymappingeditor',
      component: KeyMappingEditor,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
